/*
 * @Description:
 * @Author: 姓名
 * @Date: 2025-04-08 21:51:34
 * @LastEditTime: 2025-11-25 09:57:24
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 */
import React, { useEffect, useCallback, useMemo } from 'react'
import SignalPaymentLogo from './assets/signal_payment_logo.png'
import PaymentArea from './PaymentArea'
import { GoodsItem } from './types'
import { useAppSelector } from '../../../app/hooks'
import { calcCheckedPhotoNum } from '@/pages/components/photoLib/photo'
import { message } from 'antd'
import type { RootState } from '../../../app/store'

interface PropsType {
  goodsMsg: { id: string; price: string }
  onClose: (isSensor?: boolean) => void
  sensorClickEvent: any
}
const SignalPayment = (props: PropsType) => {
  const photoState = useAppSelector((state) => state.photo)
  // photov2 选中的照片（暂时兼容，未来将完全使用新版状态）
  const contentCheckedPhotos = useAppSelector(
    (state: RootState) => state.photosByContent?.checkedPhotos
  )
  const contentUncheckedPhotos = useAppSelector(
    (state: RootState) => state.photosByContent?.unCheckedPhotos
  )
  const contentCheckAll = useAppSelector(
    (state: RootState) => state.photosByContent?.checkAll
  )
  const contentPhotosNum = useAppSelector(
    (state: RootState) => state.photosByContent?.photosNum || 0
  )
  const contentCheckedNum = useMemo(() => {
    if (!contentCheckedPhotos && !contentCheckAll) return 0
    if (contentCheckAll) {
      const uncheckedSize = contentUncheckedPhotos?.size ?? 0
      return Math.max(0, contentPhotosNum - uncheckedSize)
    }
    return contentCheckedPhotos?.size ?? 0
  }, [
    contentCheckedPhotos,
    contentCheckAll,
    contentPhotosNum,
    contentUncheckedPhotos
  ])
  // 选中的照片数量（暂时兼容，未来将完全使用新版状态）
  const selectPhotosCounts = useMemo(() => {
    if (contentCheckedNum > 0) {
      return contentCheckedNum
    }
    return calcCheckedPhotoNum(photoState)
  }, [contentCheckedNum, photoState])
  useEffect(() => {
    if (photoState.queryFilter) {
      const queryFilter = photoState.queryFilter
      const isMoreThan3Months =
        queryFilter.times?.[1] && queryFilter.times?.[0]
          ? queryFilter.times[1].diff(queryFilter.times[0], 'months', true) > 3
          : false
      if (isMoreThan3Months) {
        message.warning('非会员仅能查看及下载90天内照片')
      }
    }
  }, [])

  const handleExport = () => {
    props.onClose()
    const elementBtn: HTMLElement | null = document.getElementById(
      'batchDownloadBtn'
    )
    if (elementBtn) {
      elementBtn.click()
    }
  }

  return (
    <div className="payment-modal__signal">
      <div className="top">
        <div className="left">
          <section>
            <span className="priceDesc">按张下载</span>
            <span className="price">{`${props.goodsMsg.price}元/张`}</span>
          </section>
          <section className="topDesc">
            <span
              style={{ marginBottom: '10px' }}
            >{`已选照片${selectPhotosCounts}张`}</span>
            <span>{`应付金额 ${selectPhotosCounts} * ${Number(
              props.goodsMsg.price
            )} = ${
              (Number(props.goodsMsg.price) * 10 * selectPhotosCounts) / 10
            } 元`}</span>
          </section>
        </div>
        <div className="right">
          <img width={146} height={146} src={SignalPaymentLogo} alt="" />
        </div>
      </div>
      <div className="remind-red">*非会员仅能查看及下载90天内照片</div>
      <div className="bottom">
        <div className="payMethods">
          <PaymentArea
            paySource="singleBatchDownload"
            selectedGoods={(props.goodsMsg as unknown) as GoodsItem}
            onClose={() => {
              // 支付完成回自动调用这里的方法
              handleExport()
            }}
            sensorClickEvent={(val) => props.sensorClickEvent(val)}
          />
        </div>
      </div>
    </div>
  )
}

export default SignalPayment
